import { arraySerializer } from './ArraySerializer';
import { booleanSerializer } from './BooleanSerializer';
import { dateSerializer } from './DateSerializer';
import { mapSerializer } from './MapSerializer';
import { numberSerializer } from './NumberSerializer';
import { serializerRegistrations } from './serializerRegistrations';
import { setSerializer } from './SetSerializer';
let isRegistered = false;
export function registerJavascriptSerializers() {
    if (isRegistered) {
        return;
    }
    serializerRegistrations.push({ type: Number, serializer: numberSerializer }, { type: Date, serializer: dateSerializer }, { type: Array, serializer: arraySerializer }, { type: Set, serializer: setSerializer }, { type: Map, serializer: mapSerializer }, { type: Boolean, serializer: booleanSerializer });
    isRegistered = true;
}
